import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'IsFilterable',
    pure: true
})
export class IsFilterablePipe implements PipeTransform {
    transform(items: any[]): any {
        if (!items) {
            return items;
        }
        
        return items.filter(item => item.FilterType);
    }
}